import {Box} from '@mui/material';
import FlatInput from '../flat-input/flat-input';
import {FlatMultiTextSelect} from '../flat-multi-text-select/flat-multi-text-select';
import {FlatSelectDropdown} from '../flat-select-dropdown/flat-select-dropdown';
import {FlatStartsAtDate} from '../flat-starts-at-date/flat-starts-at-date';
import {FlatStartsAtTime} from '../flat-starts-at-time/flat-starts-at-time';
import Switch from '../switch/switch';
import {FlatInputFeatureAutocomplete} from './feature-fields/autocomplete';
import {ActivityGroupScheduleForm} from '../activity-group-schedule-form/activity-group-schedule-form';
import {ActivityTypeScheduleForm} from '../activity-type-schedule-form/activity-type-schedule-form';
import {ActivityTypePosologyScheduleForm} from '../activity-type-posology-schedule-form';
import {CarePlanConfiguration} from '../../backend/interfaces/care-plan-configuration';
import {CarePlanConfigurationType} from '../../backend/enums/care-plan-configuration-type';
import {CarePlanConfigurationFeature} from '../../backend/enums/care-plan-configuration-feature';

const FIELDS_TYPES_MODELS: Record<CarePlanConfigurationType, any> = {
  string: FlatInput,
  number: FlatInput,
  integer: FlatInput,
  array: FlatMultiTextSelect,
  boolean: Switch,
  time: FlatStartsAtTime,
  date: FlatStartsAtDate,
  'activities-group-schedule': ActivityGroupScheduleForm,
  'activity-type-schedule': ActivityTypeScheduleForm,
  'posology-schedule': ActivityTypePosologyScheduleForm,
  autocomplete: FlatInputFeatureAutocomplete,
  'empty-space': Box,
};

/**
 *
 * Determines which Component to render per field.
 *
 * */

export const getFieldRenderComponent = (field: CarePlanConfiguration) => {
  let component = FIELDS_TYPES_MODELS[field.type];

  if (field.type === CarePlanConfigurationType.Array) {
    if (
      (field?.feature && field.feature === CarePlanConfigurationFeature.AutonomyAssessment) ||
      !field.multipleValues
    )
      component = FlatSelectDropdown;
  }

  return component;
};
